import { Injectable } from "@snap/ts-inject";
import type {
    GeoData as GeoDataOrig,
    WeatherData as WeatherDataOrig,
    HourlyWeatherForecast as HourlyWeatherForecastOrig,
} from "../lens-core-module/generated-types";
import { isArrayOfType, isNumber, isRecord, isString, isUndefined } from "../common/typeguards";

/**
 * @internal
 */
type GeoData = GeoDataOrig;

/**
 * @internal
 */
type WeatherData = WeatherDataOrig;

/**
 * @internal
 */
type HourlyWeatherForecast = HourlyWeatherForecastOrig;

export { GeoData, WeatherData, HourlyWeatherForecast };

/**
 * @internal
 */
export type GeoDataProvider = () => GeoData | undefined;

/**
 *
 * @internal
 */
export function isGeoData(value: unknown): value is GeoData {
    return isRecord(value) && isWeatherData(value.weather);
}

function isWeatherData(value: unknown): value is WeatherData {
    return (
        isRecord(value) &&
        isString(value.locationName) &&
        isNumber(value.celsius) &&
        isNumber(value.fahrenheit) &&
        !isUndefined(value.hourlyForecasts) &&
        isArrayOfType(isHourlyWeatherForecast, value.hourlyForecasts)
    );
}

function isHourlyWeatherForecast(value: unknown): value is HourlyWeatherForecast {
    return (
        isRecord(value) &&
        isNumber(value.celsius) &&
        isNumber(value.fahrenheit) &&
        isString(value.displayTime) &&
        isString(value.weatherCondition) &&
        isString(value.localizedWeatherCondition)
    );
}

/**
 * @internal
 */
export const geoDataProviderFactory = Injectable("geoDataProvider", (): GeoDataProvider => {
    return () => undefined;
});
